import React from "react";

const FaqHeader: React.FC<{
    head?: string;
    description?: string;
}> = ({ head = "Frequently asked questions", description = "Everything you need to know about the Razorpay-Gallabox integration" }) => {
    return (
        <section className="max-w-6xl py-10 mx-auto px-4">
            <div className="flex flex-col justify-center lg:gap-4 gap-2 items-center pb-6">
                <p className="lg:text-4xl text-3xl text-center font-bold text-gray-700">{head}</p>
                <h3 className="text-gray-500 text-center lg:text-2xl text-lg font-normal ">{description}</h3>
            </div>
        </section>
    );
};

export default FaqHeader;
